import { X } from 'lucide-react';

import { Progress } from '@/components/ui/progress';
import { useGetProgressQuery } from '@/services/api/demandProgressService';
import { useCancelGenerationMutation } from '@/services/api/demandService';

interface Props {
  matterId: string;
  inline?: boolean;
  className?: string;
}

export const WorkspaceDemandProgressBar = ({
  matterId,
  inline = false,
  className = '',
}: Props) => {
  const { data } = useGetProgressQuery(matterId, {
    pollingInterval: 1000,
  });

  const [cancelGeneration, { isLoading: isCancelling }] =
    useCancelGenerationMutation();

  // Only hide if no data exists or if both done and total are 0 (no progress at all)
  if (!data || (data.done === 0 && data.total === 0)) return null;
  const pct = (data.done / data.total) * 100;

  const handleCancel = () => {
    if (!isCancelling) {
      cancelGeneration({ matterId });
    }
  };

  return (
    <div
      className={`${inline ? '' : 'fixed bottom-4 right-4'} ${className} w-64 z-30 bg-white shadow-md rounded p-2`}
    >
      <div className="flex items-center gap-1">
        <Progress value={pct} className="flex-1" />
        <button
          type="button"
          onClick={handleCancel}
          disabled={isCancelling}
          className="p-0.5 rounded-full hover:bg-red-100 text-gray-500 hover:text-red-600 transition-colors flex-shrink-0 focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none"
          title="Cancel generation"
        >
          <X className="h-3.5 w-3.5" />
        </button>
      </div>
      <p className="text-center text-xs mt-1">
        Drafting demand… {data.done}/{data.total}
      </p>
    </div>
  );
};

// Deprecated alias – will be removed once all imports are migrated.
export const DemandGenProgress = WorkspaceDemandProgressBar;
